module.exports = __webpack_public_path__ + "static/media/home-service-6.adde7a03.svg";